import type {SerializedStyles} from '@emotion/react';
import type {HTMLAttributes, ReactNode} from 'react';

import {css} from '@emotion/react';
import React from 'react';

import {useAppTheme} from '../../styles';

interface LayoutMainProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
  css?: SerializedStyles;
}

const Main = (props: LayoutMainProps) => {
  const {children, css: mainCss, ...mainProps} = props;
  const {spacings, breakpoints} = useAppTheme();

  const mergedMainCss = css([
    {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: spacings.topNav.sm.height,
      minHeight: '100dvh',
      [breakpoints.sm]: {
        minHeight: 'unset',
        flexGrow: 1,
      },
      [breakpoints.lg]: {
        paddingTop: spacings.topNav.lg.height,
      },
    },
    mainCss,
  ]);

  return (
    <main
      css={mergedMainCss}
      {...mainProps}
    >
      {children}
    </main>
  );
};

export default Main;
